import React from "react";
import ProgressBar from "./ProgressBar";
import Slide from "./Slide";
import "./App.scss";

const LeadForm = ({
  slides,
  answers,
  currentSlide,
  updateAnswer,
  nextSlide,
  prevSlide,
  submitForm,
  errors,
  isSubmitted,
  checkBoxes,
  onCheckBoxChange,
  inputErrors,
  progressBarColor,
  showProgressBar,
  showProgressText,
  progressBarText,
  questionFontSize,
  questionColor,
  answerFontSize,
  answerTextColor,
  answerBgColor,
  answerSelectedBgColor,
  answerSelectedTextColor,
  answerHoverBgColor,
  answerHoverTextColor,
  disclaimerText
}) => {
  const totalSlides = slides.length + 1;
  const isLastSlide = currentSlide === slides.length - 1;

  // Get the current slide
  const currentSlideData = slides[currentSlide];

  // Determine the answer to pass
  const answer =
    currentSlideData?.type === "multiple-fields"
      ? answers
      : answers[currentSlideData?.key];

  // Redirect to success page upon submission
  React.useEffect(() => {
    if (isSubmitted) {
      window.location.href = "https://medical-guardian.com/free-quote/success/";
    }
  }, [isSubmitted]);

  return (
    <div className={`form-container${isSubmitted ? " is-submitted" : ""}`}>
      {/* FORM HEADER */}
      {!isSubmitted && showProgressBar && (
        <ProgressBar
          currentSlide={currentSlide}
          totalSlides={totalSlides}
          color={progressBarColor}
          showText={showProgressText}
          progressBarText={progressBarText}
        />
      )}
      {/* FORM BODY */}
      {!isSubmitted && (
        <Slide
          slide={currentSlideData}
          slides={slides}
          currentSlide={currentSlide}
          answer={answer}
          asnwers={answers}
          inputErrors={inputErrors}
          updateAnswer={updateAnswer}
          checkBoxes={checkBoxes}
          onCheckBoxChange={onCheckBoxChange}
          questionFontSize={questionFontSize}
          questionColor={questionColor}
          answerFontSize={answerFontSize}
          answerTextColor={answerTextColor}
          answerBgColor={answerBgColor}
          answerSelectedBgColor={answerSelectedBgColor}
          answerSelectedTextColor={answerSelectedTextColor}
          answerHoverBgColor={answerHoverBgColor}
          answerHoverTextColor={answerHoverTextColor}
          error={
            currentSlideData?.type === "multiple-fields"
              ? undefined
              : errors[currentSlideData?.key]
          }
        />
      )}
      {/* NAV BUTTONS */}
      <div className="buttons-container" style={{ display: "flex", display: `${currentSlide > 0 || (currentSlide === 0 && answer) ? "flex" : "none"}` }}>
        {!isSubmitted && (
          <button
            onClick={prevSlide}
            className="back-button"
            style={{
              cursor: "pointer",
              visibility: `${currentSlide > 0 ? "visible" : "hidden"}`
            }}
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="8" height="15" viewBox="0 0 8 15" fill="none">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M6.36842 14.0105L0 7.00526L6.36842 0L7.66331 1.17718L2.36506 7.00525L7.66331 12.8333L6.36842 14.0105Z" fill="#333333" />
            </svg> Previous Question
          </button>
        )}
        {(!isSubmitted && answer && !isLastSlide) && (
          <button onClick={nextSlide} className="continue-button button-secondary">
            Continue
          </button>
        )}
        {(isLastSlide && !isSubmitted) && (
          <button
            onClick={submitForm}
            className="submit-button"
          >Get FREE Quote</button>
        )}
        {(!isSubmitted && currentSlideData.type === "multiple-fields" && !isLastSlide) && (
          <button onClick={nextSlide} className="contact-next">
            Continue <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M6.95246 1.91396L7.64613 1.22029C7.93985 0.926571 8.4148 0.926571 8.70539 1.22029L14.7797 7.29149C15.0734 7.5852 15.0734 8.06015 14.7797 8.35074L8.70539 14.4251C8.41167 14.7188 7.93673 14.7188 7.64613 14.4251L6.95246 13.7314C6.65562 13.4346 6.66187 12.9502 6.96496 12.6596L10.7302 9.07254H1.74992C1.33434 9.07254 1 8.7382 1 8.32262V7.32273C1 6.90715 1.33434 6.57282 1.74992 6.57282H10.7302L6.96496 2.98572C6.65874 2.69512 6.65249 2.2108 6.95246 1.91396Z" fill="white" />
            </svg>
          </button>
        )}
      </div>
      {(isLastSlide && !isSubmitted) && (
        <div className="last-slide-disclaimer" style={{ textAlign: 'left' }} dangerouslySetInnerHTML={{ __html: disclaimerText }}></div>
      )}
    </div>
  );
};

export default LeadForm;
